module.exports = __webpack_public_path__ + "img/new_51.2326614e.jpg";